<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
  import downloadService from "../../../services/downloadService";

  export default {
    name: "hcCaseCalendarAttachment",
    data() {
      return {};
    },

    computed: {
      hcCaseCalendarId() {
        return this.$route.query.hcCaseCalendarId;
      },
      vbAttachmentId() {
        return this.$route.query.vbAttachmentId;
      },
      userDeptRoleId() {
        return this.$route.params.userDeptRoleId;
      }
    },

    created() {
      this.downloadFile();
    },

    methods: {
      downloadFile() {
        return downloadService
          .downloadHcCaseCalendarAttachment(
            this.hcCaseCalendarId,
            this.vbAttachmentId
          )
          .then(() => this.routingToDashboard());
      },

      routingToDashboard() {
        this.$router.replace({
          name: "dashboard",
          params: {userDeptRoleId: this.userDeptRoleId}
        });
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/lichtuan/hcCaseCalendarAttachment.vue